import { render, staticRenderFns } from "./quntityVarieties.vue?vue&type=template&id=4490d150&"
import script from "./quntityVarieties.vue?vue&type=script&lang=js&"
export * from "./quntityVarieties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports